import { Box, Button, Grid2 } from '@mui/material'
import React, { useState } from 'react'
import Modal from '@mui/material/Modal';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useLocation } from 'react-router-dom';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TextField from '@mui/material/TextField';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '@media (max-width: 767.98px)': { width: '80%' },
    width: 600,
    bgcolor: '#aeaeae',
    borderRadius: '10px',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


function CreateAgent() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const [open2, setOpen2] = useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => setOpen2(false);

    const location = useLocation();
    const path = location.pathname;




    return (
        <div>
            <div className="display-1 flex-wrap">
                <div className='crt-agent display-1'>

                    <Button onClick={handleOpen}>
                        <PersonAddAltIcon />
                        Create Agent</Button>
                </div>

                <div className='crt-player display-1'>

                    <Button onClick={handleOpen2}>
                        <PersonAddIcon />
                        Create Player</Button>
                </div>
            </div>

            <Modal
                open={open}
                // onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h3
                    >
                        Create Agent
                    </h3>
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Username " variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Password" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Confirm Password" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Payout Percentage" variant="outlined" />
                            </div>


                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Email" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Name" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Last Name" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Whatsapp Link" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Phone Number" variant="outlined" />
                            </div>
                        </Grid2>
                        <div className="display-1 flex-wrap">
                            <div className='crt-agent display-1'>

                                <Button onClick={handleClose}>
                                    {/* <PersonAddAltIcon /> */}
                                    Cancel</Button>
                            </div>

                            <div className='crt-player display-1'>

                                <Button >
                                    {/* <PersonAddIcon /> */}
                                    Create Agent</Button>
                            </div>
                        </div>
                    </Grid2>
                </Box>
            </Modal>

            <Modal
                open={open2}
                // onClose={handleClose2}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h3
                    >
                        Create Player
                    </h3>
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Username " variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Password" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Confirm Password" variant="outlined" />
                            </div>

                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Email" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Name" variant="outlined" />
                            </div>
                            <div className='pop-txt'>
                                <TextField id="outlined-basic" placeholder="Last Name" variant="outlined" />
                            </div>
                        </Grid2>
                        <div className="display-1 flex-wrap">
                            <div className='crt-agent display-1'>

                                <Button onClick={handleClose2}>
                                    {/* <PersonAddAltIcon /> */}
                                    Cancel</Button>
                            </div>

                            <div className='crt-player display-1'>

                                <Button >
                                    {/* <PersonAddIcon /> */}
                                    Create Player</Button>
                            </div>
                        </div>
                    </Grid2>
                </Box>
            </Modal>


        </div>
    )
}

export default CreateAgent
